import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IGroup } from '~/types/group/models'

const apiEntityPath = '/api/groups'

export async function getGroups({ apiPath = apiEntityPath } = {}) {
  const callingMn = getGroups.name
  return httpGet<IGroup[]>({ callingMn, apiPath })
}

export async function createGroup(entity: IGroup) {
  const callingMn = createGroup.name
  const apiPath = apiEntityPath
  return httpPost<IGroup>({ callingMn, apiPath, entity })
}

export async function updateGroup(entityData: Partial<IGroup>, id: TEntityId) {
  const callingMn = updateGroup.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIGroup = Partial<IGroup>
  return httpPatchMerge<TPartialIGroup>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteGroup(entityData: IGroup) {
  const callingMn = deleteGroup.name
  const apiPath = apiEntityPath
  return httpDelete<IGroup>({
    callingMn,
    apiPath,
    entityData,
  })
}
